module.exports = __webpack_public_path__ + "static/img/10.ec9e30b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/10.jpg
// module id = i1tL
// module chunks = 5